import Loader from "components/Loader/Loader";
import React from "react";
import "./BackdropLoader.css";

function BackdropLoader({ message = "" }) {
  return (
    <div
      className="backdrop-loader"
      style={{
        backgroundColor: "rgb(8 8 8 / 70%)"
      }}
    >
      <div className="backdrop-text-center loading">
        <div className="backdrop-spinner-border" role="status">
          <Loader color="light" />
        </div>
        {message ? (
          <p
            style={{
              color: "white",
              zIndex: 9999,
              fontSize: "1.2rem",
              fontWeight: "bold",
              position: "absolute",
              top: "55%",
              left: "50%",
              transform: "translate(-50%, -50%)"
            }}
          >
            {message}
          </p>
        ) : null}
      </div>
    </div>
  );
}

export default BackdropLoader;
